import { useIntl } from 'react-intl';
import AccionaBigButton from '../../../components/AccionaBigButton';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Project = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { me } = useSelector(({ auth }) => auth);

  return (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <AccionaBigButton
            icon="quality"
            msg={intl.formatMessage({ id: 'routes.quality' })}
            onClick={() => navigate('quality')}
            disable={me?.role === 'USER MADUREZ'}
          />
        </div>
        <div className="col-sm-12 col-md-6">
          <AccionaBigButton
            icon="strength"
            msg={intl.formatMessage({ id: 'routes.strength' })}
            onClick={() => navigate('strength')}
            disable={me?.role === 'USER CALIDAD'}
          />
        </div>
      </div>
      {me?.role === 'ADMIN' && (
        <div className="row">
          <div className="col-sm-12">
            <AccionaBigButton
              icon="config"
              msg={intl.formatMessage({ id: 'routes.options' })}
              onClick={() => navigate('options')}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Project;
